import React from 'react';
import PropTypes from 'prop-types';

import './ProductQuestionsAndAnswersThankYou.scss';

const ProductQuestionsAndAnswersThankYou = ({ message, pretext = 'Thank You!' }) => (
	<div className="ProductQuestionsAndAnswersThankYou">
		<span className="ProductQuestionsAndAnswersThankYou__icon lpIcon-success" />
		<div className="ProductQuestionsAndAnswersThankYou__text">
			<strong>
				{pretext}
			</strong>
			{' '}
			{message}
		</div>
	</div>
);

ProductQuestionsAndAnswersThankYou.propTypes = {
	message: PropTypes.string.isRequired,
	pretext: PropTypes.string
};

export default ProductQuestionsAndAnswersThankYou;
